import type { DraftStatus } from "@app/shared";
import { Badge } from "./ui/badge";

const VARIANT_BY_STATUS: Record<
  DraftStatus,
  "secondary" | "navy" | "teal" | "green" | "coral"
> = {
  draft: "secondary",
  approved: "navy",
  scheduled: "teal",
  posted: "green",
  failed: "coral",
};

const LABEL_BY_STATUS: Record<DraftStatus, string> = {
  draft: "Draft",
  approved: "Approved",
  scheduled: "Scheduled",
  posted: "Posted",
  failed: "Failed",
};

/** Colored badge reflecting a draft's lifecycle status. */
export function StatusBadge({ status }: { status: DraftStatus }) {
  return (
    <Badge variant={VARIANT_BY_STATUS[status]}>{LABEL_BY_STATUS[status]}</Badge>
  );
}
